import React, { Component } from 'react'
import { COLORES } from '../../../config/colores'

class VerificarPatenteDialogView extends Component {
  render () {
    const { cpe } = this.props

    return (
      <div style={{ margin: '-1%', overflow: 'hidden' }}>
        <div style={{ backgroundColor: COLORES.blue.primary, color: '#ffffff', width: '100%', padding: '5px 0', marginBottom: '0' }}>
          <h4 style={{ textAlign: 'left', margin: '0 5%' }}> Calle {cpe.calleDeIngreso} </h4>
        </div>
        <div className='text-center'>
          <p className='confirmacion-patente-calado-text'>Por favor verificar la patente</p>
          <h1>{cpe && cpe.patenteCamion}</h1>
        </div>
        <div>
          <img className='foto-calado' src={cpe && cpe.foto} alt='Foto Patente' />
        </div>
      </div>
    )
  }
}

export default VerificarPatenteDialogView
